<template>
	<div class="ReSearchScndObjects">
			<tabs type="primary" 
				:activeTab="value"
				@change="OnTabChange"
				tabContentClasses="tab-opt"
				centered
				inline
				round		
				v-loading.fullscreen.lock="$GVO.fullscreenLoading"
				element-loading-text="Загрузка данных..."
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)"	
				class="card card-plain">
				<tab-pane :id="'flats'" >
					<template v-slot:label>
						<span class="tab-label">
							<i class="tab-icon tim-icons icon-align-left-2"></i><span>Список</span>
						</span>
					</template>
					
					<div>
						<h3 class="text-center" v-if="masObjects.length==0">Ничего не найдено</h3>	
						<!-- <h3 class="text-center" v-if="masObjects.length==0">Поиск...</h3>	 -->
						<template v-if="value == 'flats'">			
							<ReSearchScndObjSmall v-for="obj in masObjects" :key="obj.id" :objData="obj"/>
						</template>
					</div>

				</tab-pane>

				<tab-pane :id="'flatmap'" class="flat">
					<template v-slot:label>
						<span class="tab-label">
							<i class="tab-icon tim-icons icon-map-big"></i><span>Карта</span>
						</span>
					</template>
					<div class="card-wrapper">
						<div class="card-wrapper-center row px-3">
							<h3 class="text-center" v-if="masObjects.length==0">Ничего не найдено</h3>

							<ReSearchScndObjMap v-if="value == 'flatmap'" :objData="masObjects"/>
						</div>
					</div>
				</tab-pane>
				
			</tabs>
			<!-- <h6><span v-if="value == 'flats'">Список</span><span v-if="value == 'flatmap'">Список</span> </h6> -->
	</div>
</template>

<script>
	import { TabPane, Tabs } from 'src/components';
	import ReSearchScndObjSmall from 'src/our_modules/SearchSendObjects/ReSearchScndObjSmall.vue'; 
	import { Select, Option, Tooltip, Button } from 'element-ui';
	import ReSearchScndObjMap from 'src/our_modules/SearchSendObjects/ReSearchScndObjMap.vue';

	//import { Loading } from 'element-ui';

	export default {
		name: 'ReSearchScndObjects',
		components: {
            TabPane, 
			Tabs,
			ReSearchScndObjSmall,
			[Option.name]: Option,
			[Select.name]: Select,
			[Tooltip.name]: Tooltip,	
			[Button.name]: Button,
			ReSearchScndObjMap,
			//Loading,

		},
		props: {
			masObjects: [Array,Object],
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: {
				type: String,
				default: 'flats', // flats||flatmap
			}, 
		},
		data () {
			return {
				ver: 1,
				fullscreenLoading: false,
				
				masAdSource: {
					options: [
						{value: '0',label: '1 - avito.ru',},
						{value: '1',label: '2 - irr.ru',},
						{value: '2',label: '3 - realty.yandex.ru',},
						{value: '3',label: '4 - cian.ru',},
						{value: '4',label: '5 - sob.ru',},
						{value: '5',label: '6 - youla.io',},
						{value: '6',label: '10 - moyareklama.ru',},
					],
				},
				/*
				bIsObject: this.IsObject(),
				bIsFlat: this.IsFlat(),
				bIsMap: this.IsMap(),*/
			}
		},
		computed: {

		},
		methods: {
			OnTabChange(strTabId){
				this.$emit('input', strTabId);
				this.$emit('change', strTabId);
			},
		},
	}
</script>
<style scoped>
.ReSearchScndObjects >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.ReSearchScndObjects >>> .tab-content {margin-top: 15px;}

.card-wrapper {width: 100%; }
.card-wrapper-center {
    justify-content: center;
    margin: 0 auto;
    display: flex;
	max-width: 3000px;
}

/*===media===============================*/
@media (max-width: 768px) {
	.flat .row {width: 100%; margin-left: 0px;}
}

</style>
